module.exports = __webpack_public_path__ + "img/natsuyoshi.cd195f98.jpg";